const DERASAR = {
  name: 'Sample Derasar',
  address: '123 Temple Street',
  city: 'Ahmedabad',
  contactPhone: '9876543210',
  contactEmail: 'admin@derasar.org',
};

export const SAMPLE_DATA = {
  balanceSheet: {
    derasar: DERASAR,
    assets: {
      total: 250000,
      subGroups: [
        { name: 'Current Assets', subtotal: 150000, rows: [{ name: 'Cash in Hand', accountCode: 'CSH001', balance: 80000 }, { name: 'Bank Account', accountCode: 'BNK001', balance: 70000 }] },
        { name: 'Fixed Assets',   subtotal: 100000, rows: [{ name: 'Building Fund', accountCode: 'FXD001', balance: 100000 }] },
      ],
    },
    liabilities: { total: 20000, subGroups: [{ name: 'Current Liabilities', subtotal: 20000, rows: [{ name: 'Payables', accountCode: 'LIA001', balance: 20000 }] }] },
    equity:      { total: 180000, rows: [{ name: 'Corpus Fund', accountCode: 'EQT001', balance: 180000 }] },
    incomeExpense: { surplus: 50000 },
    totalLiabilitiesEquity: 250000,
    isBalanced: true,
  },

  incomeExpense: {
    derasar: DERASAR,
    rows: [
      { category: 'Angi', income: 120000, expense: 30000, surplus: 90000 },
      { category: 'Dev Dravya', income: 80000, expense: 20000, surplus: 60000 },
      { category: 'Jiv Daya',  income: 40000, expense: 10000, surplus: 30000 },
    ],
    totalIncome: 240000, totalExpense: 60000, surplus: 180000,
  },

  trialBalance: {
    derasar: DERASAR,
    rows: [
      { accountCode: 'CSH001', accountName: 'Cash in Hand', drBalance: 80000,  crBalance: 0 },
      { accountCode: 'BNK001', accountName: 'Bank Account', drBalance: 70000,  crBalance: 0 },
      { accountCode: 'INC001', accountName: 'Donation Income', drBalance: 0, crBalance: 150000 },
      { accountCode: 'EXP001', accountName: 'Expenses',     drBalance: 0,   crBalance: 0  },
    ],
    grandTotalDr: 150000, grandTotalCr: 150000, isBalanced: true,
  },

  categoryFund: {
    derasar: DERASAR,
    categories: [
      { category: 'Angi',      openingBalance: 50000, income: 120000, expense: 30000, closingBalance: 140000 },
      { category: 'Dev Dravya', openingBalance: 30000, income: 80000, expense: 20000, closingBalance: 90000  },
      { category: 'Jiv Daya',  openingBalance: 10000, income: 40000, expense: 10000, closingBalance: 40000  },
    ],
    commission: { openingBalance: 5000, income: 12000, expense: 3000, closingBalance: 14000 },
  },

  dayBook: {
    derasar: DERASAR,
    rows: [
      { voucherNo: 'DR001', entryType: 'receipt', narration: 'Cash donation from member', totalDr: 5000,  totalCr: 0    },
      { voucherNo: 'PV001', entryType: 'payment', narration: 'Expenses paid',              totalDr: 0,    totalCr: 2000 },
      { voucherNo: 'DR002', entryType: 'receipt', narration: 'Bank donation received',     totalDr: 10000, totalCr: 0   },
    ],
    summary: { totalReceipts: 15000, totalPayments: 2000, net: 13000 },
  },

  cashBook: {
    derasar: DERASAR,
    openingBalance: 20000,
    closingBalance: 33000,
    rows: [
      { date: '2025-04-01', voucherNo: 'DR001', narration: 'Cash donation', debit: 5000,  credit: 0,    balance: 25000 },
      { date: '2025-04-02', voucherNo: 'PV001', narration: 'Expenses paid', debit: 0,    credit: 2000, balance: 23000 },
      { date: '2025-04-05', voucherNo: 'DR002', narration: 'Cash donation', debit: 10000, credit: 0,   balance: 33000 },
    ],
  },

  bankBook: {
    derasar: DERASAR,
    openingBalance: 50000,
    closingBalance: 68000,
    rows: [
      { date: '2025-04-01', voucherNo: 'DR003', bankAccountName: 'HDFC Current', narration: 'NEFT received', debit: 20000, credit: 0,    balance: 70000 },
      { date: '2025-04-03', voucherNo: 'PV002', bankAccountName: 'HDFC Current', narration: 'Vendor payment', debit: 0,   credit: 2000, balance: 68000 },
    ],
  },

  goldRegister: {
    derasar: DERASAR,
    totalGrams: 25.5, totalInr: 153000,
    receipts: [
      { date: '2025-04-01', receiptNo: 'GR001', category: 'Angi',      goldGrams: 10, goldPurity: 22, valuationRate: 6000, amountInr: 60000 },
      { date: '2025-04-05', receiptNo: 'GR002', category: 'Dev Dravya', goldGrams: 15.5, goldPurity: 24, valuationRate: 6000, amountInr: 93000 },
    ],
  },

  itemRegister: {
    derasar: DERASAR,
    totalItems: 2, totalInr: 25000,
    receipts: [
      { receiptDate: '2025-04-01', receiptNo: 'IR001', donationCategory: { name: 'Angi' },      narration: 'Silver utensils', amountInr: 15000 },
      { receiptDate: '2025-04-10', receiptNo: 'IR002', donationCategory: { name: 'Dev Dravya' }, narration: 'Idol donation',   amountInr: 10000 },
    ],
  },

  ledger: {
    derasar: DERASAR,
    account: { name: 'Cash in Hand', accountCode: 'CSH001' },
    closingBalance: 33000,
    rows: [
      { date: '2025-04-01', voucherNo: 'DR001', narration: 'Cash donation', debit: 5000,  credit: 0,    balance: 25000 },
      { date: '2025-04-02', voucherNo: 'PV001', narration: 'Expenses paid', debit: 0,    credit: 2000, balance: 23000 },
    ],
  },

  offeringAging: {
    derasar: DERASAR,
    rows: [
      { donorName: 'Ramesh Shah',  category: 'Angi',      pledgeDate: '2025-01-01', pledgedAmount: 10000, paidAmount: 5000, pendingAmount: 5000,  daysPending: 90 },
      { donorName: 'Priya Mehta',  category: 'Dev Dravya', pledgeDate: '2025-02-15', pledgedAmount: 8000,  paidAmount: 0,    pendingAmount: 8000,  daysPending: 45 },
    ],
  },

  memberContributions: {
    derasar: DERASAR,
    rows: [
      { userId: '1', memberName: 'Ramesh Shah',  offeredAmount: 10000, paidAmount: 8000,  pendingAmount: 2000 },
      { userId: '2', memberName: 'Priya Mehta',  offeredAmount: 5000,  paidAmount: 5000,  pendingAmount: 0    },
      { userId: '3', memberName: 'Suresh Patel', offeredAmount: 8000,  paidAmount: 3000,  pendingAmount: 5000 },
    ],
  },

  pendingBalance: {
    derasar: DERASAR,
    relevant: [
      { name: 'Ramesh Shah',  totalPledged: 10000, totalPaid: 5000,  totalPending: 5000 },
      { name: 'Suresh Patel', totalPledged: 8000,  totalPaid: 3000,  totalPending: 5000 },
    ],
    totalPledged: 18000, totalPaid: 8000, totalPending: 10000,
  },

  memberLedger: {
    derasar: DERASAR,
    totalEntries: 2, totalPledged: 10000, totalPaid: 5000, totalPending: 5000,
    memberOfferings: [
      { offeringDate: '2025-01-15', donationCategoryId: { name: 'Angi' },      offeredAmount: 5000, paidAmount: 5000, pendingAmount: 0,    status: 'completed' },
      { offeringDate: '2025-02-20', donationCategoryId: { name: 'Dev Dravya' }, offeredAmount: 5000, paidAmount: 0,   pendingAmount: 5000, status: 'pending'   },
    ],
  },

  ownerLedger: {
    derasar: DERASAR,
    totalEntries: 4, totalPledged: 15000, totalPaid: 8000, totalPending: 7000,
    byPerson: [
      { name: 'Ramesh Shah',    count: 2, pledged: 8000,  paid: 5000, pending: 3000 },
      { name: 'Meena Shah',     count: 2, pledged: 7000,  paid: 3000, pending: 4000 },
    ],
  },

  familyReport: {
    derasar: DERASAR,
    familyGroups: [
      {
        label: 'Shah Family',
        pledged: 18000, paid: 11000, pending: 7000,
        members: [
          { name: 'Ramesh Shah', pledged: 10000, paid: 8000, pending: 2000 },
          { name: 'Meena Shah',  pledged: 8000,  paid: 3000, pending: 5000 },
        ],
      },
      {
        label: 'Patel Family',
        pledged: 5000, paid: 5000, pending: 0,
        members: [
          { name: 'Suresh Patel', pledged: 5000, paid: 5000, pending: 0 },
        ],
      },
    ],
  },

  receiptsBook: {
    derasar: DERASAR,
    totalAmount: 25000,
    rows: [
      { receiptDate: '2025-04-01', receiptNo: 'DR001', memberName: 'Ramesh Shah',  donationCategory: { name: 'Angi' },       paymentMode: 'cash', amountInr: 10000 },
      { receiptDate: '2025-04-05', receiptNo: 'DR002', memberName: 'Priya Mehta',  donationCategory: { name: 'Dev Dravya' },  paymentMode: 'bank', amountInr: 15000 },
    ],
  },

  anonymousDonations: {
    derasar: DERASAR,
    totalAmount: 8000,
    filtered: [
      { receiptDate: '2025-04-01', receiptNo: 'AN001', donorName: null,          donationCategory: { name: 'Jiv Daya' }, paymentMode: 'cash',   amountInr: 5000 },
      { receiptDate: '2025-04-10', receiptNo: 'AN002', donorName: 'Unknown Donor', donationCategory: { name: 'Angi' },  paymentMode: 'cheque', amountInr: 3000 },
    ],
  },
};
